import { Fragment } from "react";
import { Grid, useMediaQuery } from "@mui/material";

import { EntityInput } from "@dzambalaorg/mui-inputs-entity";
import { SearchWithFilters } from "@dzambalaorg/mui-form-search";
import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import type { IPaginationResult } from "@dzambalaorg/types-collection";
import { StyledEmptyWrapper, StyledPagination } from "@framework/styled";
import { IProduct } from "@framework/types";
import { useFetchQuery } from "@dzambalaorg/react-hooks";

import { ProductItem } from "./item";

export const ProductList = () => {
  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount } = useFetchQuery<
    IPaginationResult<IProduct>
  >("/products", { enableInfiniteScroll: isMd });

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "ecommerce", "products"]} />

      <PageHeader message="pages.products.title" />

      <SearchWithFilters>
        <Grid container spacing={2}>
          <Grid size={{ xs: 6 }}>
            <EntityInput multiple name="categoryIds" controller="ecommerce/categories" />
          </Grid>
        </Grid>
      </SearchWithFilters>

      <ProgressOverlay isLoading={isLoading}>
        <Grid container spacing={2}>
          <StyledEmptyWrapper count={allRows.length} isLoading={isLoading}>
            {allRows.map(product => (
              <Grid size={{ lg: 4, sm: 6, xs: 12 }} key={product.id}>
                <ProductItem product={product} />
              </Grid>
            ))}
          </StyledEmptyWrapper>
        </Grid>
      </ProgressOverlay>

      {!isMd && totalCount > take && (
        <StyledPagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}
    </Fragment>
  );
};
